import { urlConfig, urlControlPanel } from '@/urls';
import { ContactInfo } from '@/components/config/contact-info';
import { Location } from '@/components/config/location';
import { Description } from '@/components/config/description';
import { MapPicker } from '@/components/config/map-picker';
import { ClubImages } from '@/components/config/club-images';

function Config() {
  return (
    <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
      <ContactInfo />
      <ClubImages />
      <Location />
      <MapPicker />
      <Description />
    </div>
  );
}

export const route = {
  index: true,
  path: urlConfig(':id'),
  element: <Config />,
  handle: {
    title: 'Gestión del Club',
    backLink: (params: { id: string }) => urlControlPanel(params.id),
  },
};
